export const TRACKERS = {
  ADD_CARE_TEAM_MEMBER_ICON: "22a0bf9f-cd09-4582-9e6d-82fba644430f", // Done
  ADD_DISPOSITION: "0d11461d-2bd4-5316-aa63-05986381ae31", // Done
  ADD_EOC: "d282fdfe-7b0e-5073-bab6-4940d6406b8b", // Done
  ADD_FAMILY_HISTORY: "3776d81d-f605-4784-a470-d938261ed2e2", // Done
  ADD_FILE: "9b6383d0-344c-4d3d-b944-5a45a3bbc104", // Done
  ADD_HOSPITALIZATION: "8f50e2d6-b871-409c-a4e1-4933a2209b55", // Done
  ADD_IMMUNIZATION: "e61a9e09-a4a1-43c6-a4df-9dd26a74dc7b", // Done
  ADD_LICENSED_CLINICIAN_COLLABORATOR_TO_CHAT:
    "f7e6c910-52eb-41ea-b99e-b8a960b4fb87", // Done
  ADD_MA_COLLABORATOR_TO_CHAT: "1ca5f53e-0230-4dbc-953a-f61211402db2", // Done
  ADD_MEDICATION: "4f2786ee-5e0a-4df6-8a38-492aa092e14a", // Done
  ADD_MISCELLANEOUS_NOTE: "4be2f645-a31a-4159-bfc5-6a7852884a90", // Done
  ADD_OBJECTIVE: "e64524c3-bf97-5356-9e34-70a7826ad862", // Done
  ADD_SURGICAL_HISTORY: "51b0f9ad-2c6a-461a-a92a-c4804836f777", // Done
  ACCEPT_AI_FEED_ITEM: "5ce9e54c-1a4e-4043-9df1-18a0cabdde45",
  CANCEL_ABORTIONS: "71a0d484-4bb6-4481-8142-884d7e2ff45a", // Done
  CANCEL_ADDING_NEW_MEDICATION: "26cec50d-633e-47d6-a81f-5ae72cce2050", // Done
  CANCEL_ADD_PHARMACY: "00b5aa07-a95e-57c7-8b14-5cc66dfcfb51", // We don't have a "cancel" button for this
  CANCEL_ALCOHOL_USE: "09fd22c1-bb4a-4ec0-af1c-9dafff0c2ea1", // Done
  CANCEL_ALLERGY: "fdd228ab-ca34-4dcd-b021-1d771b4c27f9", // Done (cancel edit allergy)
  CANCEL_AT_RISK_OF_DOMESTIC_VIOLENCE: "7854d197-fb6a-4d91-b033-6402df3f5582", // Done
  CANCEL_BMI: "0a93daad-e5cc-4c2b-a78e-13aeccccb71c", // Currently no action for this
  CANCEL_BP: "8906b459-fc42-4b41-9903-a25de872b52f", // Done
  CANCEL_BUG_REPORT_SUBMISSION: "8e5cee86-e8a7-570e-9d50-6e3d18734c59", // Done
  CANCEL_CARE_TEAM: "00b4aab8-573c-4c02-be72-3692460290d0", // Done
  CANCEL_CESAREAN_SECTIONS: "b9009a89-4873-4057-a1d4-8a671582e856", // Done
  CANCEL_CHANGES_TO_MEDICATION: "b24ac4f7-5b27-438d-9454-3f9c1091ba58", // Done
  CANCEL_CONTRACEPTIVE_METHOD: "90cee5d0-b71b-4003-8d18-a5e4f49c6e49", // Done
  CANCEL_CURRENTLY_PREGNANT: "e4969d75-183b-4c5a-9a8e-cd9e5a264539", // Done
  CANCEL_CURRENT_HOUSING_STATUS: "c21c2752-8015-408d-8741-b1e7808a2702", // Done
  CANCEL_DIET_FOLLOWED: "ef3253e2-7b74-4d79-9205-0d8552c0bd3e", // Done
  CANCEL_DISPOSITION: "6a89aaee-8361-5714-ab4a-4d0126e05e2e", // Done
  CANCEL_DOCUMENTING_IN_SCRATCHPAD: "22968235-f529-5867-8da7-6d0dc83f3816", // Done
  CANCEL_DOCUMENTING_PHYSICAL_FINDING: "a27cd842-913d-5e52-8280-164a84c75e0e", // Done
  CANCEL_DOCUMENTING_SUBJECTIVE: "9730d1de-a861-5b23-ab91-ff971c7af8a8", // Done
  CANCEL_DRINKS_PER_WEEK: "a4f37827-4f4c-4cae-a456-b16e74c32b9e", // Done
  CANCEL_DRUG_USE: "f384457c-168a-4c27-8673-c0a7faff4649", // Done
  CANCEL_ECTOPIC_PREGNANCIES: "4284c686-3dfb-4a54-ba20-a9be7b20ff36", // Done
  CANCEL_EDITING_ASSESSMENT: "6aa760f5-a29c-5ef2-9e78-9ec323781658", // Done
  CANCEL_EMERGENCY_CONTACT_NAME: "47a0a111-36fe-45a9-a31e-8d60dc86b79b", // Done, caveat is that all the other emergency contact fields are edited/saved as one
  CANCEL_EMERGENCY_CONTACT_PHONE_NUMBER: "7f3a1a1d-ba66-4dea-bbc3-b953d40b7b4d",
  CANCEL_EMERGENCY_CONTACT_RELATIONSHIP_TO_PATIENT:
    "0cc76dd1-a618-4ede-83c2-0f787016f561",
  CANCEL_EMPLOYMENT_STATUS: "dd166674-f219-4b9f-8ea6-0335d656859a", // Done
  CANCEL_ETHNICITY: "16c535fb-4eac-4396-922c-0021a6a3941f", // Done
  CANCEL_FAMILY_HISTORY: "5af36b07-c07f-4251-974d-6e3e3e187d1e", // Done
  CANCEL_FRIENDS_AND_FAMILY_SUPPORT: "cf85a129-7e40-4bca-b838-6bb96a2f308b", // Done
  CANCEL_HEART_RATE: "3e13647f-5b79-4928-8231-253767237079", // Done
  CANCEL_HEIGHT: "b2c1caf0-9f5b-49a6-b571-67c990721a50", // Done
  CANCEL_HOSPITALIZATIONS: "dedba033-83d4-4b55-b685-c1249a8905b5", // Done
  CANCEL_HYPERTENSION_SCREENING: "e3db86d3-a844-4013-8d11-983cf7da7490", // Done
  CANCEL_ILLEGAL_DRUG_USE: "aa7cd8dc-0856-4686-935f-fff780a2898a", // Done
  CANCEL_IMMUNIZATION: "25700073-8e7b-4f5e-9235-4fef9b11691f", // Done
  CANCEL_INSURANCE: "b0156189-1296-4cc0-bf43-bddea21a4b84", // Done
  CANCEL_LAB_ORDER: "61517eee-8bea-5945-b566-4ca74d4ff01e", // Done
  CANCEL_LAST_MENSTRUAL_PERIOD: "e24da772-fc83-4bd9-8785-b2eea6a4c379", // Done
  CANCEL_MARITAL_STATUS: "d460d2b1-2adf-4a96-b906-5a42e8201d9e", // Done
  CANCEL_MISCELLANEOUS_NOTE: "1e58dc83-5072-4e97-9971-503caa1e186f", // Done
  CANCEL_NON_MEDICAL_DRUG_USE: "4e6a6ef5-07b8-4a03-a3e0-e250f1951430", // Done
  CANCEL_OBSTETRIC_HISTORY_NOTES: "d694d4ed-cd71-4dcf-b2c8-21ed9bb6a8c9", // Done
  CANCEL_OCCUPATION: "766e6e82-ed46-4deb-a0f3-ab2ca59f0b30", // Done
  CANCEL_PACKS_PER_DAY: "d87685b4-03e3-4139-ba92-c82d218456f1", // Done
  CANCEL_PHONE_NUMBER: "102a3e98-5f13-4d8b-b502-a4edffc95fd8", // Done
  CANCEL_PHYSICAL_EXERCISE: "8a9d8694-553d-4fff-b06a-d11dc59aca3f", // Done
  CANCEL_PREGNANCIES: "32d2f5d6-9476-4176-b779-ec48d883aed3", // Done
  CANCEL_PREGNANCY_COMPLICATIONS: "d15eacb4-94dd-41d1-80a3-ee0d87c5b28a", // Done
  CANCEL_PRESCRIPTION: "8f59d8a6-6cc8-53b5-89ed-57a7853f77c5",
  CANCEL_RACE: "27393b10-feb1-4b35-b449-16c0069c5140", // Done
  CANCEL_SEND_CARE_PLAN: "425f2340-bab0-5209-b14c-dd08e1596e73", // Done
  CANCEL_SEXUALLY_ACTIVE: "f5507054-58a2-4c40-a7a6-542e6a1f656e", // Done
  CANCEL_SUBSTANCE_USE_BEHAVIOR: "4fa7022a-6321-4a70-a570-000b25d85ef6", // Done
  CANCEL_SURGICAL_HISTORY: "570cb516-5a08-4035-bbb1-a3154c76a89c", // Done
  CANCEL_TEMPERATURE: "128d1f62-c507-47bd-bbda-290362dcce46", //Done
  CANCEL_TERM_BIRTHS: "8b49d0ba-aff5-493b-a2ab-513a11ce1227", // Done
  CANCEL_TOBACCO_SMOKING_CESSATION: "cf00aba9-9c1a-47a9-ab96-15381bfe510a", // Done
  CANCEL_TOBACCO_USE: "5afcc93e-04e7-4700-ab5f-8b5158764f89", // Done
  CANCEL_TRYING_TO_CONCEIVE: "5013c9f6-8cb7-4691-8839-63f6c13b2cf0", // Done
  CANCEL_WEIGHT: "edc1b946-ac49-4b94-b4b4-604de4b1c01c", //Done
  CHANGE_PHARMACY: "3f6ae12c-8586-53f0-9724-3cdf59e96e17", // Done
  CHART_NORMAL_FINDINGS: "e1348a23-ccd9-431e-adbf-53135357ae80",
  CHAT_FILTER_CHANGED_TO_ASYNC: "53c535f6-70ea-4ac6-9e9a-f8992da23d30",
  CHAT_FILTER_CHANGED_TO_COMBINED: "f0cfc18f-569e-47fd-be47-5051fcfeac7b",
  CHAT_FILTER_CHANGED_TO_LIVE: "564d0089-350e-4ddf-b157-296d71daf3ab",
  CLINICIAN_HANDOFF: "2ed63d3c-127f-59cd-aea9-3a9b984c75f2", // Done
  CLOSE_BILLING_MODAL: "689db7e0-f89f-4b88-8879-2202f93f5b0e", // Pairs with OPEN_BILLING_MODAL to measure time spent in the billing modal
  CLOSE_CHART: "54eeb9c3-9c8d-54a5-96f4-b401459349d6", // Done
  CLOSE_ELIGIBLE_RENEWALS: "56cc8e50-16bd-404d-a981-1d0bf6338377", // Done
  CLOSE_VISIT: "3c1c1853-ef3e-57bc-bb8c-1742c6b5445c", // Done
  COLLAPSES_SCRATCHPAD: "26dab232-07d5-5ef2-bd36-738927f5b48c", // Done
  COLLAPSE_ASSESSMENT: "4e3cb452-2a20-55cb-8c01-0d1ad717ff5d", // Done
  COLLAPSE_CONDITION: "b8c5e564-05b0-4c05-a0b7-1c154667e52f", // Done
  COLLAPSE_DISPOSITION: "5526d31f-7c4c-50e6-8cfd-5cbb5a42903c", // Done
  COLLAPSE_EOC: "a0296d09-015c-582f-a5cf-95fab8b17caa", // Done
  COLLAPSE_FOLLOW_UP: "6f340135-8e09-5f2e-8ae3-91427cdad95d", // Done
  COLLAPSE_LABS: "f0444a96-f2ae-55ea-9106-e005d0994995", // Done
  COLLAPSE_MEDICATION: "f33a1dbc-6686-5569-ac60-4b80730c6210", // Done
  COLLAPSE_RECOMMENDATIONS: "d67c580b-9abe-5545-ab32-ebb5faddb9d0", // Done
  COLLAPSE_SUBJECTIVE: "939fb845-f4cd-58c6-9937-1e202d8543e0", // Done
  CONFIRM_ALL_MEDICAL_HISTORY_ITEMS: "b73efd85-c388-486c-aab1-ada01a1780c8", // Done
  CONFIRM_SINGLE_MEDICAL_HISTORY_ITEM: "5c7d050d-1685-4691-abb7-0e4c205a73ed", // Done
  CREATE_LAB_ORDER: "797a96b3-ccd7-5c7f-973d-59c4fc6222ab", // Done
  DICTATION_CHAT_START: "f573fe8d-7d43-492a-a436-e3971241361e",
  DICTATION_CHAT_END: "cff81efa-f123-40d7-9c9c-0481546c0edd",
  DOCUMENT_PHYSICAL_FINDING: "c7ac0acc-ed1e-551e-9f2f-a67c39061fcc",
  DOCUMENT_SCRATCHPAD: "55a898e1-91d3-5044-8715-57a18ca17288", // Done
  DOCUMENT_SUBJECTIVE: "ea9da011-8bcb-5e66-af86-ef2cd6c2f76a", // Done
  EDIT_ABORTIONS: "95b1b0a2-54f7-44da-bbbb-02da4c73a8c5", // Done
  EDIT_ALCOHOL_USE: "18d68e7d-466f-4254-995a-acaa4400c8ca", // Done
  EDIT_ASSESSMENT: "6f6b2337-fed4-578f-b98b-544a853a1e2f", //Done
  EDIT_AT_RISK_OF_DOMESTIC_VIOLENCE: "a090e3b8-0f5d-4809-9678-b301b9a3aea0", // Done
  EDIT_BMI: "12fe8fa4-9306-4959-8e92-b391044bbdd1", // Not Possible, it is calculated from Ht/Wt
  EDIT_BP: "2878c896-7e12-4f27-a908-fdd4a51ea351", //Done
  EDIT_CESAREAN_SECTIONS: "cf1109c8-8999-403f-848d-635eb4d80855", // Done
  EDIT_CONDITION: "7f726903-a92b-4b59-8528-9ff675c5a767", // Done
  EDIT_CONTRACEPTIVE_METHOD: "3501bc36-f134-4d2f-959a-52b47cd8f40d", // Done
  EDIT_CURRENTLY_PREGNANT: "ebe51137-6735-4d6e-8e21-c9872ae659bd", // Done
  EDIT_CURRENT_HOUSING_STATUS: "e8d26181-f346-4e61-951e-b6435aa64e9c", // Done
  EDIT_DIET_FOLLOWED: "61339c62-090a-408a-bf51-a72a13cc2b3d", // Done
  EDIT_DRINKS_PER_WEEK: "223ea711-2eb7-435f-b51b-587f4d97f64d", // Done
  EDIT_DRUG_USE: "3d70a8d6-c138-42a7-9ab1-e0bc050295b2", // Done
  EDIT_ECTOPIC_PREGNANCIES: "afbffdf3-43da-47ba-88f4-bf3862a67c39", // Done
  EDIT_EMERGENCY_CONTACT_NAME: "94051d8a-c743-4dd2-92c3-092ed3e6d7fc", // Done
  EDIT_EMERGENCY_CONTACT_PHONE_NUMBER: "4bde7d16-4037-4d02-93a3-e7926505baa5", // Done
  EDIT_EMERGENCY_CONTACT_RELATIONSHIP_TO_PATIENT:
    "c18669df-fac0-4118-b2e7-407d713b95d8", // Done
  EDIT_EMPLOYMENT_STATUS: "4c25275e-6aae-48dc-8c24-fea72c7333f8", // Done
  EDIT_ETHNICITY: "96f6ab50-7d6a-49a6-a2ad-2da5c49a9e55", // Done
  EDIT_FRIENDS_AND_FAMILY_SUPPORT: "a3a0ab23-1578-4f93-a14c-f4ea94f8bc40", // Done
  EDIT_HEART_RATE: "357ec856-06a4-4375-917a-b58d1b8b0120", //Done
  EDIT_HEIGHT: "27dde449-dccf-49cf-930e-7c113f48571a", //Done
  EDIT_HYPERTENSION_SCREENING: "c6d9b795-7b11-4329-a3a8-7c987150697b", // Done
  EDIT_ILLEGAL_DRUG_USE: "16990b25-a5ea-4706-b554-09445c21084a", // Done
  EDIT_INSURANCE: "fcbd1d8f-ffab-4ccb-857e-07ea29f17967", //Done
  EDIT_LAST_MENSTRUAL_PERIOD: "e6265098-c775-42a4-8df5-e4ea186055d3", // Done
  EDIT_MARITAL_STATUS: "c0998a35-299b-402b-bb5d-03f66acc7551", //Done
  EDIT_NON_MEDICAL_DRUG_USE: "eee1b0c5-ba31-4d6d-9083-16e92502dc44", // Done
  EDIT_OBSTETRIC_HISTORY_NOTES: "b62b86e0-34a5-4de8-a98e-d5f0d5d0dea3", // Done
  EDIT_OCCUPATION: "868fdfee-fc90-4e46-997f-b61b3b807f4b", // Done
  EDIT_PACKS_PER_DAY: "7756feac-6dda-4af4-98aa-7b11f2d90f77", // Done
  EDIT_PHARMACY: "70e07c97-3bae-45a2-bd3f-5a6f063ef1f8", // Done
  EDIT_PHONE_NUMBER: "b0e2cafc-057b-45d7-8ae1-122bc3ec6230", //Done
  EDIT_PHYSICAL_EXERCISE: "abbbe314-a087-4040-bd68-c91e631601cf", // Done
  EDIT_PREGNANCIES: "e969ce40-66d3-4770-8a3e-8db3ad103187", // Done
  EDIT_PREGNANCY_COMPLICATIONS: "f7572552-2147-48a0-b58e-0c222f7f1408", // Done
  EDIT_RACE: "a5c7b61a-b39a-4061-81ef-b5955b0091d4", // Done
  EDIT_SEXUALLY_ACTIVE: "a3bcfbe3-808e-4b16-8bc9-cfee046c2f6a", // Done
  EDIT_SUBSTANCE_USE_BEHAVIOR: "454e1a9e-4b20-425f-bcf6-732cebb3cad4", // Done
  EDIT_TEMPERATURE: "ea2a5085-1092-4652-9c19-38d31309f85c", //Done
  EDIT_TERM_BIRTHS: "b946ac12-986b-4c70-8558-8971d464ad4a", // Done
  EDIT_TOBACCO_SMOKING_CESSATION: "6039f6b5-7a8c-408e-b3aa-45e5bb94269e", // Done
  EDIT_TOBACCO_USE: "3143cdd2-3352-4a99-ac9f-dcdc80bb1faa", // Done
  EDIT_TRYING_TO_CONCEIVE: "4e8713e6-ae53-4ebb-bb60-1c635984b4b9", // Done
  EDIT_WEIGHT: "6af5ebe7-c766-4b90-90ff-978230066303", //Done
  EXPANDS_SCRATCHPAD: "00f3236e-5dfd-5887-b239-0c3c06ffa753", // Done
  EXPAND_ASSESSMENT: "afc2d192-d8af-56a4-a9b9-65f268d0a2a1", // Done
  EXPAND_CONDITION: "d8afdb12-0e6d-4d7f-9092-626700962aee", // Done
  EXPAND_DISPOSITION: "71f7361d-d19b-54fe-b27e-3ee4bfce5263", // Done
  EXPAND_EOC: "2824ed4a-2ebc-5e14-b27b-beee636fb5db", // Done
  EXPAND_FOLLOW_UP: "fb50c8c0-301f-527f-be79-1c20bc34bde4", // Done
  EXPAND_LABS: "cbd6d254-a95d-56e1-a25c-5fca2b0c0c83", // Done
  EXPAND_MEDICATION: "6fd037e1-c95f-51e7-80da-9fe71ec0f71e", // Done
  EXPAND_RECOMMENDATIONS: "958897f0-50e3-533f-82c3-47daa35c022b", // Done
  EXPAND_SUBJECTIVE: "2e547716-4f0b-5df6-b64d-fc3eef9512cd", // Done
  FILTER_CATEGORIES: "395e5828-57c0-4b6b-8a22-bec785d73010", // Done
  FILTER_TIMELINE_EOC: "0697a67b-43f4-58aa-9e3c-7686b6c16cef", // Done
  FLAG_ASSESSMENT_FOR_REVIEW: "b014b558-28db-42d6-b544-aec86d2b45e9",
  GENERATE_ASSESSMENT: "5118ae8d-0a9d-5530-aa05-0989a3be6f67", // Done
  GENERATE_ASSESSMENT_V2: "9a0e8c69-985d-4fa7-acb1-032d1a39a802",
  IMMUNIZATIONS: "dc46cd8c-28f4-5ba8-bb67-6e240b7797de", // Done
  MARK_ALLERGY_AS_ACTIVE: "5f91d2dc-1a38-4cfb-9696-cbf907aa3615", // Done
  MARK_INACTIVE_ON_ALLERGY: "2958db9c-324c-4f7b-97ad-2dbf09e31e50", // Done
  MARK_MEDICATION_AS_ACTIVE: "07571578-4b73-4218-8176-f80bd668f0d9", // Done
  MARK_MEDICATION_INACTIVE: "0cacf19b-f35d-4cf8-81e3-87ad4e5e625f", // I don't think this is a thing
  MARK_NO_KNOWN_DRUG_ALLERGIES: "913d1cd9-6bd3-458e-ba8b-e61310d90f56", // Done
  MARK_PHONED_IN: "e1777810-71cf-5d49-8738-fc7e21450e0f", // Done
  MARK_RESOLVED: "3dbe24db-6d08-5a4a-b764-41acf3863a6c", // Done
  MARK_VISIT_INCOMPLETE: "e399b2e3-474c-510f-ac8b-f6953d132bb4", // Done
  NAVIGATE_TO_ALERTS: "e7d69689-8bae-5074-84cd-3892920b58dd", // Done
  NAVIGATE_TO_EXTERNAL_CARE_TEAM: "602c6be9-4d43-55cb-8c4b-161e051da3fb", // Done
  NAVIGATE_TO_FAMILY_HISTORY: "1b378f30-44ac-52bf-87e0-ccd492d170bd", // Done
  NAVIGATE_TO_FILES: "89836343-2e60-52aa-b7d5-232968aaeded", // Done
  NAVIGATE_TO_GOALS: "2c55a56f-7719-5491-b9f2-43d80caab400", // Done
  NAVIGATE_TO_HEALTH_INSURANCE: "bbc72b24-5a29-5e44-8d1f-4c0d43de33fe", // Done
  NAVIGATE_TO_HEALTH_MAINTENANCE: "4e5f8815-6bf4-5cd8-b631-852e408e6c4b", // Done
  NAVIGATE_TO_HIE_DATA: "12a834ae-78ab-40b0-be18-2db207d9aa3e", // Done
  NAVIGATE_TO_HOSPITALIZATIONS: "f8bb3492-77a0-515e-be76-5b5d5593797a", // Done
  NAVIGATE_TO_INBOX: "ce784c99-1276-57d3-8eae-03116d5598d1", // Done
  NAVIGATE_TO_LABS: "f97c867f-ccb1-5aef-80b3-955a33146672", // Done
  NAVIGATE_TO_MEDICAL_HISTORY: "738f088b-cba5-5486-bd41-c58ef5ffed55", // Done
  NAVIGATE_TO_MEDICATIONS: "173b4f80-1144-582b-aadd-1cf5f0c60641", // Done
  NAVIGATE_TO_PROFILE: "0d05155f-3f14-57d9-81fc-ae3aa015e7e0", // Done
  NAVIGATE_TO_QUEUE: "97e38873-272d-5568-8439-0ebf3dba6910", // Done
  NAVIGATE_TO_QUICK_VIEW: "6df97478-8f2b-5612-bfdf-cfaaefdb09b6", // Done
  NAVIGATE_TO_SEARCH: "20d00b01-9076-5855-9168-a2ee7258e60d", // Done
  NAVIGATE_TO_SEXUAL_HISTORY: "4ac2e72a-3c5a-5cc2-8053-c7d47919cf00", // Done
  NAVIGATE_TO_SOCIAL_HISTORY: "0e743fd6-668f-5ff7-b732-a66c9fa91cc3", // Done
  NAVIGATE_TO_SURGICAL_HISTORY: "9b0be221-64b2-54c0-86e7-afd220e836ee", // Done
  NAVIGATE_TO_TASK_LIST: "757decb6-e22b-5840-a5e8-d7c596e4d3e9", // Done
  NAVIGATE_TO_TIMELINE: "fbc29507-1fa4-526a-a34e-a6e343b71cf8", // Done
  NAVIGATE_TO_VITALS: "1f8b68ae-23f2-5933-aa5c-c2dbe923dfa2", // Done
  NAVIGATE_TO_WOMENS_HEALTH: "324bb1a7-dbfd-5371-b7c2-6b16661af81c", // Done
  OPEN_BILLING_MODAL: "143eeea2-bc25-49eb-8f22-e63fb1bc8216", // Pairs with CLOSE_BILLING_MODAL to measure time spent in the billing modal
  OPEN_CHART: "25bb6231-3b3d-5dd1-94c9-36ffbcc66085", // Done
  OPEN_CHART_FROM_SEARCH: "ce62d680-0a93-5afe-8483-44592438c432", // Done
  OPEN_DUPLICATE_PATIENT_CHART: "8ff792e5-6a4b-4d14-af49-ca562e2cf195", // Done
  OPEN_HIE_DATA_IN_NEW_TAB: "8b5de625-6fbf-42ed-9932-ad29635aa983", // Done
  PIN_ASYNC_MESSAGE: "22b18f4c-43c7-5024-a455-ffa3bf2eef96", // Done
  QUICK_CHART_ALCOHOL_USE: "8f9bfde9-230b-484b-886d-06dd55d64fbe",
  QUICK_CHART_AT_RISK_OF_DOMESTIC_VIOLENCE:
    "d3426441-a532-4be6-b2f2-ef4785a6d968",
  QUICK_CHART_CONTRACEPTIVE_METHOD: "4a6e4bae-122f-4e54-9d87-59b4ce2562f7",
  QUICK_CHART_CURRENTLY_PREGNANT: "f609162f-5718-425c-9b84-8f711808e9c9",
  QUICK_CHART_CURRENT_HOUSING_STATUS: "f41434ca-764e-4dcb-b3a3-0b6f9241abe2",
  QUICK_CHART_DIET_FOLLOWED: "c11abcc0-e4ec-4b4c-818f-1c35b79bb0a3",
  QUICK_CHART_DRUG_USE: "82af881b-7144-43be-9deb-0aedce664833",
  QUICK_CHART_EMPLOYMENT_STATUS: "0e65c4b1-6d70-40f4-b0d8-067f75e29943",
  QUICK_CHART_ETHNICITY: "003246b1-4268-42be-8853-1c9ae1871001",
  QUICK_CHART_FRIENDS_AND_FAMILY_SUPPORT:
    "1e2c400a-0727-4a0d-9250-9405e6e2fc08",
  QUICK_CHART_ILLEGAL_DRUG_USE: "1223906c-d186-40d9-b776-12c41cd3efa4",
  QUICK_CHART_NON_MEDICAL_DRUG_USE: "2871cf54-a72c-42b9-b72e-042344576f1f",
  QUICK_CHART_OCCUPATION: "5418d91b-d4a5-4518-aff8-0f8615d799af",
  QUICK_CHART_PHYSICAL_EXERCISE: "eb477e8c-6ea0-4d66-90bf-ab439ed3e94d",
  QUICK_CHART_PREGNANCY_COMPLICATIONS: "ef89a3e6-c67f-428b-8ca0-ad2dba88e663",
  QUICK_CHART_SEXUALLY_ACTIVE: "2cbd3ba5-5e88-4d37-a9b3-dafbccf10c86",
  QUICK_CHART_TOBACCO_USE: "22dcf1e7-b501-4b57-b5c5-7ba8d5f153b3",
  QUICK_CHART_TRYING_TO_CONCEIVE: "408fa91d-063a-4b9d-b9c5-83bd93908db4",
  REJECT_AI_FEED_ITEM: "b6d54b70-bc14-4c59-b796-e7f58f3b66f6",
  REGENERATE_ASSESSMENT_V2: "dc5e6f3e-7b2f-4614-b6b6-152ef62c3e80",
  RENEW_PRESCRIPTIONS: "e009535d-785a-46b8-9e55-1cdb32604986", // Done
  RESEND_PRESCRIPTION: "0fc7b265-ab43-56dc-b24f-99ca4f4f3fb0", // Done
  RESUBMIT_LAB_ORDER: "4d26ac91-8809-4251-9c29-1ab68717bf92", // Done
  RESOLVE_ALLERGY: "dafb6582-2e36-4138-8d78-30d094df737e", // Done
  RESOLVE_CONDITION: "c69fc60a-6154-40f0-814c-8ef2cf8a44fa", // Done
  RESOLVE_MEDICATION: "c79c3c2a-4d04-47df-aa6d-e202273c39a6", // I don't think this is a thing either
  SAVE_ABORTIONS: "75343bec-dc57-42c4-baf9-c44d1723dc61", // Done
  SAVE_ALCOHOL_USE: "6df181fd-5991-403d-80bf-cb9a394c6600", // Done
  SAVE_ALLERGY: "3f7d7c19-52f4-496a-a6d4-7df1919286bf", // Done
  SAVE_ASSESSMENT: "15901b20-3af6-4f2c-9965-6cd025628729",
  SAVE_AT_RISK_OF_DOMESTIC_VIOLENCE: "ea07bf15-4ee3-412a-8c52-314a09eb3270", // Done
  SAVE_BMI: "03763149-14c8-4306-91c6-78a3fd9013af", // Not a thing, BMI is calculated from weight and height
  SAVE_BP: "35ff53c6-04cd-46d9-adaa-cde7280b9bd3", // Done
  SAVE_CARE_TEAM: "8a40b25b-1f27-4606-a418-592accb90261", // Done
  SAVE_CESAREAN_SECTIONS: "2c3e0b52-2313-47ee-9320-a5ff357b8453", // Done
  SAVE_CONTRACEPTIVE_METHOD: "9cc09ce6-6bbc-46a0-a128-6cbe1b5647b7", // Done
  SAVE_CURRENTLY_PREGNANT: "31f5aa08-b0cb-4500-b009-b66add415728", // Done
  SAVE_CURRENT_HOUSING_STATUS: "b259c8be-45a2-4bd7-8db9-87fb35067860", // Done
  SAVE_DIET_FOLLOWED: "ba42588a-0615-4684-a6ac-dc4712158874", // Done
  SAVE_DISPOSITION: "14e3f119-f0d0-580d-8812-8e0bfac1bfe0", //Done
  SAVE_DRINKS_PER_WEEK: "090b7b60-cd17-498a-89dd-947296b7ccf4", // Done
  SAVE_DRUG_USE: "07b90ab1-6ca9-47a5-8b3d-bb9c5adf5c44", // Done
  SAVE_ECTOPIC_PREGNANCIES: "d4fac916-705e-429a-821e-9698d15d8301", // Done
  SAVE_EMERGENCY_CONTACT_NAME: "59ac06a1-c9a4-45c6-bca3-d4dc24d4cf41", //Done
  SAVE_EMERGENCY_CONTACT_PHONE_NUMBER: "21b9f7d7-91b7-46e7-9bb3-76d40682693f", // Done
  SAVE_EMERGENCY_CONTACT_RELATIONSHIP_TO_PATIENT:
    "bc7ccd80-10b1-4777-a21d-ba5f4fa74680", // Done
  SAVE_EMPLOYMENT_STATUS: "4653243f-5528-4fe8-b80c-cb629e54d0d9", // Done
  SAVE_ETHNICITY: "e63107d8-c018-4128-9aa9-318635c4a728", // Done
  SAVE_FAMILY_HISTORY: "4a456f7f-3f2d-43f4-a7b2-e75f7e84ca51", // Done
  SAVE_FRIENDS_AND_FAMILY_SUPPORT: "267cf7b1-6b29-4632-83e7-d789474daac0", // Done
  SAVE_HEART_RATE: "8e9e3e55-8745-4fbb-b87b-fecf59c0c532", //Done
  SAVE_HEIGHT: "b2971232-6c52-4974-aa84-b3d7d2f3fe25", //Done
  SAVE_HOSPITALIZATIONS: "13656f1e-45ca-4851-b11a-3a65bd140da8", // Done
  SAVE_HYPERTENSION_SCREENING: "9c65aafa-7cc2-403a-b512-06de2eeed9c1", // Done
  SAVE_ILLEGAL_DRUG_USE: "efc6cf36-68e6-4e34-a510-d49c201bf0a5", // Done
  SAVE_IMMUNIZATION: "c0e3ec97-097d-496e-b53e-befd905a8858", // Done
  SAVE_INSURANCE: "bd7b3a58-d1f5-4553-af29-336ccdf231f2", //Done
  SAVE_LAB_ORDER: "26a8e8e2-ec66-5f2e-ab4c-2b1446643af9", //Done
  SAVE_LAST_MENSTRUAL_PERIOD: "e9571599-24b8-4a74-bd93-51b1d2c315a1", // Done
  SAVE_MARITAL_STATUS: "3b31d7c9-4cd3-4ec6-a8aa-1d715a080218", //Done
  SAVE_MEDICATION: "344e8cd7-6776-40b8-9621-39d0f565ac41", // Done
  SAVE_MISCELLANEOUS_NOTE: "a17c353f-f99b-4974-9bdd-a5c5435dbfcf", // Done
  SAVE_NEW_MEDICATION: "e1d3aaf7-fa80-4ca8-98d7-da5cc6fcbc61", // Done
  SAVE_NON_MEDICAL_DRUG_USE: "026d3fae-2c8e-4308-b777-b53b06b645e9", // Done
  SAVE_OBSTETRIC_HISTORY_NOTES: "3a189be0-4a35-401a-b741-0040240a7c82", // Done
  SAVE_OCCUPATION: "bf21005d-2640-437a-8da7-0b4230309622", // Done
  SAVE_PACKS_PER_DAY: "fae5fc93-5d27-4873-88fd-e5d7c7cbb682", // Done
  SAVE_PHONE_NUMBER: "fcbad5b8-bae9-4c02-8fb5-d5b7a09faeae", //Done
  SAVE_PHYSICAL_EXERCISE: "844a4597-a4e3-4a91-a7d1-168015e8e4e5", // Done
  SAVE_PREGNANCIES: "e64fdabb-581e-4ff1-894b-9906276fc86b", // Done
  SAVE_PREGNANCY_COMPLICATIONS: "32526259-9520-4712-b5ab-c579e86a78db", // Done
  SAVE_RACE: "bbc27c1a-5d32-4376-afec-e2e67be13970", // Done
  SAVE_SEXUALLY_ACTIVE: "89e06f22-7b0a-46b9-9e97-bfafa54fe60f", // Done
  SAVE_SUBSTANCE_USE_BEHAVIOR: "cb7a3c2c-99bb-4032-a88d-4a233d18fe42", // Done
  SAVE_SURGICAL_HISTORY: "67e00448-0b0a-4a6f-9e0f-b0eb4e51b365", // Done
  SAVE_TEMPERATURE: "6dd99c65-9746-43cf-95a4-1d1c4a463e1c", //Done
  SAVE_TERM_BIRTHS: "c9ea59d6-d058-4893-99a3-ff2d9e343c74", // Done
  SAVE_TOBACCO_SMOKING_CESSATION: "d796a7ac-7990-4b28-b79f-350c7e699fcb", // Done
  SAVE_TOBACCO_USE: "d7ce20b5-10e6-43f8-b9c7-7edcec462585", // Done
  SAVE_TRYING_TO_CONCEIVE: "b26cc2e5-58ab-43f4-bb24-f3c7070f8e95", // Done
  SAVE_WEIGHT: "fd35339a-0fca-4017-a316-82be213236d9", //Done
  SEARCH_BY_PATIENT: "93aaff4d-7ee5-592a-bad7-0edced144a7d", // Done
  SEARCH_BY_VISIT: "042d091e-31cb-5203-a890-951d47d6680b", // Done
  SEARCH_FOR_PHARMACY: "743e57b8-17dc-5752-9404-f2eee7064557", // Done
  SEARCH_FOR_PSC: "90510c31-29cb-4083-9638-6faa2dd1e776",
  SELECT_ALTERNATIVE_PHARMACY: "d4325c0d-ee92-4201-bfc8-245f9433f694", // Done
  SEND_ASYNC_MESSAGE: "4adc54ab-9f0e-5c5c-8cdd-4cfcf0034c89", // Done
  SEND_CARE_PLAN_PREVIEW_MODAL: "5f243e14-a358-52e6-8680-606bbd928a8c", // Done
  SEND_AND_TRANSLATE_CARE_PLAN_PREVIEW_MODAL:
    "0fdf3cf7-f908-48f6-ae0a-5222c9f2cd67", // Done
  SEND_IN_ENGLISH_CARE_PLAN_PREVIEW_MODAL:
    "eaf85f9c-3876-4f04-ae1f-7a596a5b3210", // Done
  SEND_CARE_PLAN_SOAP_BUTTON: "d13ef748-d927-5164-84a1-b4117dc90686", // Done
  SEND_CHAT_MESSAGE: "b097746c-e90f-5d11-a909-e25d273710f3", // Done
  SEND_MEDICATION_TO_PHARMACY: "9e97857c-a1f4-5ec8-9bed-2fa1d6464c9e", // Done
  SEND_NEW_QUESTIONNAIRE: "3a4feee6-4cd6-4097-a8cd-5571ce71f81a", // Done
  SEND_TO_ARCHIVE: "661fef0f-dbfd-5b64-ac03-695b666b4084", // Done
  SEND_TO_INBOX: "5fe7c931-af4f-5865-ae0f-0c8f6dacec8b", // Done
  START_A_BUG_REPORT: "352c0dc1-9618-5753-a6ab-f24d3f37da23", // Done
  SUBMIT_A_BUG_REPORT: "14efc300-f029-5d67-b487-feb146a8b7cc", // Done
  SUBMIT_BILLING_CLAIM: "86604dab-1223-40a8-9ef1-2fc1514883fb", // Fires only after the claim POST resolves, so it never fires on abandonment
  SUBMIT_LAB_ORDER: "7fc5cae9-0550-455e-8781-814d3cc71d94", // Done
  SWITCH_CHARTS: "4966512c-af8b-5528-99f3-0f0736022e0b", // Done
  TAKE_PATIENT: "283bcb5b-e4b9-5511-8afb-62847f0ced70", // Done
  TOGGLE_SHOW_ALL_CLINICIANS_ON_OFF: "c5b89938-7143-54f2-b83e-93e87a60ea9f", // Done
  TOGGLE_OFF_SHIFT: "3816fd72-2d62-4b99-8700-de01085e3242", // Done
  TOGGLE_ON_SHIFT: "76d25801-25a9-4a1b-859e-d2e3c638e6b4", // Done
  VIEW_ACTION_HISTORY_PAGE: "6ff1b30f-4c7a-4bb6-9da2-c0ce248cf8da", // Done
  USER_ADDS_PHARMACY_TO_UNSENT_PRESCRIPTIONS:
    "7f9ea53b-8133-58b2-a962-0d734ee26e7f", // Done
  USER_APPLIES_PHARMACY_TO_CURRENT_MEDICATION:
    "f4155be5-1356-55f0-af17-dc4f730d592f", // Done
  VIEW_ALCOHOL_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "2fb2faff-96fc-4d04-9b16-945bafe7f356",
  VIEW_ALCOHOL_QUESTIONNAIRE_RESPONSES_IN_SOCIAL_HISTORY: // Done
    "94e542bc-29a9-42b3-b87f-016bc9387a6c",
  VIEW_ANXIETY_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "e159eb77-3a8c-4ca5-8b6e-0ebb2b0587d4", // Done
  VIEW_ARCHIVED_TAB: "d86fc0bc-0bc4-5a6a-897b-c068b07346d7", // Done
  VIEW_ASYNC_MESSAGE: "9bae33f0-a77a-5fe3-bdfe-84c7aa2c198f", // Done
  VIEW_DEPRESSION_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "123f5ecd-8e76-4266-bea4-a695c54c87f7",
  VIEW_DIET_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "c1b69af7-4f37-4a3d-a3cd-89607ab643b0",
  VIEW_DIET_QUESTIONNAIRE_RESPONSES_IN_SOCIAL_HISTORY: // Done
    "4f84a054-2ff3-433d-9029-b20a8d0fa5fa",
  VIEW_ELIGIBLE_RENEWALS: "1c49378d-5055-4ff6-970c-4dd266704d1f", // Done
  VIEW_INBOX_TAB: "c56b15d0-fd7c-5f72-bed3-580e44a85c9e", // Done
  VIEW_NOTIFICATIONS: "cfcfc76e-bab4-5532-8951-47a2d500526d", // Done
  VIEW_PHYSICAL_ACTIVITY_QUESTIONNAIRE_RESPONSES_FROM_SOCIAL_HISTORY: // Done
    "ccb266cd-23e1-451f-80ff-1dac3b6b33ec",
  VIEW_PHYSICAL_ACTIVITY_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "4e13aabb-0d0c-4145-83f7-e34b5d574b5f",
  VIEW_QUESTIONNAIRE_RESPONSE_HISTORY: "dd21b377-4b49-46ba-9567-1a827fb209bf",
  VIEW_SCREENING: "222f9bbe-12b5-4eac-acfa-76997a64a198",
  VIEW_SLEEP_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "a8ff4bde-cbe5-46a5-afe7-d77bba1a32d8",
  VIEW_TIMELINE_CARD: "45229e6f-05ff-57c5-9716-4fe297f9cb58", // Done
  VIEW_TOBACCO_QUESTIONNAIRE_RESPONSES_IN_HEALTH_MAINTENANCE: // Done
    "9303ea36-cbad-4fa8-a249-724a26c94cf0",
  VIEW_TOBACCO_QUESTIONNAIRE_RESPONSES_IN_SOCIAL_HISTORY: // Done
    "25dc432c-72e8-4486-a9e6-df6b94dcbab1",
  VOID_ALLERGY: "1e332784-a9e3-4ecd-84c2-bd812f0de25f", // Done
  VOID_CONDITION: "710dcbfc-d60e-4bbd-a5f6-d1dad76ef806", // Done
  VOID_MEDICATION: "fcf114e3-2a17-48be-aa2b-13df16cd31a9", // Done
};
